/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator All Banks
 *
 */

Intesa.LoanCalculatorAll = function() {

 	/**
     * Local variables
     *
     */
	var loan = this;
    var development = false;


	var yourDataIsOpen = false;
	var navigator;
	
	//popolato nel functions.js
	this.allBanksCalculators = [];
	/**
	 * Global variables
	 *
	 */
	this.urlParams = {};



	this.init = function() {
		loan.attachChangeEvents();
		loan.changeToArab();
		if($(".filters-grouped.row.text-center").length > 0 && document.getElementsByClassName("com15__filterItem js-loan-filter-hero-btn j-filterItem active").length > 0 ){
			setTimeout(function() {
				document.getElementsByClassName("com15__filterItem js-loan-filter-hero-btn j-filterItem active")[0].click();
			 }, 1500);
			if(window.outerWidth < 768 && document.getElementsByClassName("com15__filterItem js-loan-filter-hero-btn j-filterItem active").length > 0 ){
				document.getElementsByClassName("com15__filterItem js-loan-filter-hero-btn j-filterItem active")[0].className = "com15__filterItem js-loan-filter-hero-btn j-filterItem";
			}
		}

		if($('[data-calculator]').length > 0) {
    		$('.pageTemplate').addClass('calculator-detail-page');
		}
	}


    this.changeToArab = function() {
    	var lang = $('html')[0].getAttribute('lang');
    	console.log("change numbers");
    	if(lang.indexOf("ar") > -1){
	    	var inputsToReplace = $(".loanCalculator__step-number");
	    	var inputsToReplaceMobile = $(".loanCalculator__step-title");
	    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
	    	$(inputsToReplace).each(function(index, element){
	    		var chars = $(element).text().split('');
	    		 for (var i = 0; i < chars.length; i++) {
	    			 if (parseFloat(chars[i]) > -1) {
		                chars[i] = arabicNumbers[chars[i]];
	    			 }
	    		}
	    		 $(element).text(chars.join(''));
	            
	    	});
	    	$(inputsToReplaceMobile).each(function(index, element){
	    		var chars = $(element).text().split('');
	    		 for (var i = 0; i < chars.length; i++) {
	    			 if (parseFloat(chars[i]) > -1) {
		                chars[i] = arabicNumbers[chars[i]];
	    			 }
	    		}
	    		 $(element).text(chars.join(''));
	            
	    	});
    	}
        //return chars.join('');
    }
    /**
     * Attach Change Events
     *
     */
    this.attachChangeEvents = function() {
    	
    	$(window).scroll(function(){
    		if(loan.allBanksCalculators != null){
    			$(loan.allBanksCalculators).each(function(index, elem){
    				if($(elem)[0].activeCalculator != null){
			    		if($(window).width() > 991 && $($(elem)[0].activeCalculator).length > 0){
			    			if($(".calculators-custom-filters").length > 0){
			    				if($("html").attr("data-bank") == "CIB"){
									var heightRight = $(".monthlyInstallment__inner", $(elem)[0].activeCalculator).height();
									var heightLeft = $(".loanCalculator", $(elem)[0].activeCalculator).height();
									if (heightRight > heightLeft) {
										return false;
									}
								}
			    	    		if($(window).scrollTop() > $(".calculators-custom-filters").position().top){
			    	    		    if(($(".desktop-loan", $(elem)[0].activeCalculator).height() + $(".calculators-custom-filters").position().top) > $(window).scrollTop()){
			    	    		        if(($(window).scrollTop()- $(".calculators-custom-filters").position().top + $(".monthlyInstallment", $(elem)[0].activeCalculator).height()) < $(".desktop-loan", $(elem)[0].activeCalculator).height() ){
			    	    		             //condizione quando scroll verso l'alto
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("top", $(window).scrollTop()- $(".calculators-custom-filters").position().top);
			    	    		        } else {
			    	    		            //condizione quando scroll verso il basso
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().attr("style", "");
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("bottom", 0);
			    	    		        }
			    	    		        var lang = $('html')[0].getAttribute('lang');
			    	    		        if(lang.indexOf("ar") > -1){
			    	    		        	$(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("left", "24px");
			    	    		        } else {
			    	    		        	$(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("right", "24px");
			    	    		        }
			    	    		        $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("position", "absolute");
			    	    		    }
			    	    		} else {
			    	    		 //return to top
			    	    		 $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().attr("style", "");
			    	    		}
			    				
			    				
			    				
			    			} else {
			    				if($("html").attr("data-bank") == "CIB"){
									var heightRight = $(".monthlyInstallment__inner", $(elem)[0].activeCalculator).height();
									var heightLeft = $(".loanCalculator", $(elem)[0].activeCalculator).height();
									if (heightRight > heightLeft) {
										return false;
									}
								}
			    	    		if($(window).scrollTop() > $($(elem)[0].activeCalculator).position().top){
			    	    		    if(($(".desktop-loan", $(elem)[0].activeCalculator).height() + $($(elem)[0].activeCalculator).position().top) > $(window).scrollTop()){
			    	    		        if(($(window).scrollTop()- $($(elem)[0].activeCalculator).position().top + $(".monthlyInstallment", $(elem)[0].activeCalculator).height()) < $(".desktop-loan", $(elem)[0].activeCalculator).height() ){
			    	    		             //condizione quando scroll verso l'alto
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("top", $(window).scrollTop()- $($(elem)[0].activeCalculator).position().top);
			    	    		        } else {
			    	    		            //condizione quando scroll verso il basso
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().attr("style", "");
			    	    		            $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("bottom", 0);
			    	    		        }
			    	    		        var lang = $('html')[0].getAttribute('lang');
			    	    		        if(lang.indexOf("ar") > -1){
			    	    		        	$(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("left", "24px");
			    	    		        } else {
			    	    		        	$(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("right", "24px");
			    	    		        }
			    	    		        $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().css("position", "absolute");
			    	    		    }
			    	    		} else {
			    	    		 //return to top
			    	    		 $(".monthlyInstallment", $(elem)[0].activeCalculator).parent().attr("style", "");
			    	    		}
			    				
			    				
			    			}
			    		}
    				}
    			});
    		}
    	});
    	
    	$(".loanCalculator__footer .loanCalculator__btn, .calculator-desktop .slick-dots").click(function(){
			var selector = $(".calculators-custom-filters").length > 0 ? ".calculators-custom-filters" : ".calculator-desktop";
			$('html, body').animate({
				scrollTop: $(selector).position().top 
			}, 1000);
    	});
    	
    	$(document).on('click', '.js-call-me',function(e) {
    		$('[data-bs-target="#cmbModal"]').click();
    		console.log("Opening Modal")
    	});
    	
    	/*$("[id*=bookAppLoan]").click(function(){
    		$(this).parents(".monthlyInstallment").find(".js-calculator-close").trigger("click");   		
    	});
    	*/
		$(document).on('click', '.loanCalculator__radio', function() {
			var $input = $(this).find('input[type="radio"]');
			var radioGroup = $(this).find('input[type="radio"]').attr("name");
			console.log("element" + $(this).find('input[type="radio"]'));
			$("[name='" + radioGroup + "']").each( function() {
				if($(this).is($input) )
				{	
					$(this).parents('.loanCalculator__radio').addClass("selected");
				}
				else {
					$(this).parents('.loanCalculator__radio').removeClass("selected");
				}
			})

		})

		$(document).on('click', '.js-loan-hero-btn', function() {
            $(".calculator-desktop .monthlyInstallment").parent().attr("style", "");
			if($(window).width() < 768){
			var $calculator = $('.calculator-mobile');

				if($calculator.length){
					$('body').addClass('calculator-mobile-open');
					$calculator.show();
				}
			}
		});
		
		
		$(document).on('click', '.js-loan-filter-hero-btn', function() {
			var divForCalculator = $(".com15__filterContainer").find("div[data-filter="+$(this).attr("data-filter")+"]");
			console.log("calculator found " + divForCalculator);
            $(".calculator-desktop .monthlyInstallment").parent().attr("style", "");
			if($(window).width() < 992){
			var $calculator = $(divForCalculator).find('.calculator-mobile');

				if($calculator.length){
					$('body').addClass('calculator-mobile-open');
					$calculator.show();
					$calculator.parents(".com15__filter").css("transform", "none");
					$($calculator.find(".tab-mobile")[0]).show();
				}
			}
		});
		
		
		$(document).on('click',".filters-grouped a", function(event){
			console.log("element" + $(this));
	    	var elId = $(this);
	    	var elm = $(".filters-grouped a");
            console.log(elm);
			var dataFilter = $(this).attr("data-filter");
			$("div[data-filter='"+dataFilter+"']").find(".increaseHoverEffect ").addClass("campoAttivo"); 	
			$("div[data-filter='"+dataFilter+"']").find(".increaseHoverEffect ").find('.monthlyInputText').prop('disabled', false);
			$("div[data-filter='"+dataFilter+"']").find(".increaseHoverEffect ").find('.rangeslider').slider('enable');
			$("div[data-filter='"+dataFilter+"']").find(".increaseHoverEffect ").find('[data-slider-repayment]').prop('disabled', false);
            $(elm).removeClass("active");
            $(elm).removeClass("collapsed");
            $(elId).addClass("collapsed");
            $(elm).each(function(index, el){
            	$($(el).attr("data-target")).collapse('hide');
            });
            $($(elId).attr("data-target")).collapse('toggle');
            
	    });

		$(document).ready(function(){
			if($(window).width() < 768){
				var $loanHeroBtn = $(".js-loan-hero-btn");
				var $heroBtnmobileContainer = $('.heroBtnMobileContainer');
				var $heroBtnDesktopContainer = $('.heroBtnDesktopContainer');
				if($heroBtnmobileContainer.length > 0) {
					$heroBtnmobileContainer.insertAfter($(".respondImage"));
				}
				if($heroBtnDesktopContainer.length > 0) {
					$heroBtnDesktopContainer.insertAfter($(".respondImage "));
				}
				if($loanHeroBtn.length > 0) {
					$loanHeroBtn.parent().insertAfter($("footer"));

					loan.updateHeroButtonPositionWhenScrolling($loanHeroBtn);
				}
			}
		});


		$(document).on('click', '.js-loan-filter-hero-btn', function() {
			var divForCalculator = $(".com15__filterContainer").find("div[data-filter="+$(this).attr("data-filter")+"]");
			console.log("calculator found " + divForCalculator);
			if($(window).width() < 768){
				var $calculator = $(divForCalculator).find('.calculator-mobile');

				if($calculator.hasClass('investment-calculator')) return;

				if($calculator.length){
					$('body').addClass('calculator-mobile-open');
					$calculator.show();
					$calculator.parents(".com15__filter").css("transform", "none");
					$($calculator.find(".tab-mobile")[0]).show();
				}
			}
		});
		
		if($(window).width() > 768 && $(".com15__filterItem.js-loan-filter-hero-btn.j-filterItem.FHB-0").length && !$(".com15__filterItem.js-loan-filter-hero-btn.j-filterItem.FHB-0").hasClass("collapsed")){
		    $(".com15__filterItem.js-loan-filter-hero-btn.j-filterItem.FHB-0").click();
		}

	}

	this.updateHeroButtonPositionWhenScrolling = function($loanHeroBtn) {
		var $heroBtn = undefined;
		$heroBtn = $loanHeroBtn.parent();

		if ($heroBtn.length > 0) {
			var bodyHeight = $('body').height();
			var isFixedPosition = true;
			$(window).on('scroll', function () {
				var isCalculatorOpen = $('.calculator-mobile-open').length > 0;
				var windowBottomScrollPosition = $(window).scrollTop() + $(window).innerHeight();
				if (isFixedPosition && !isCalculatorOpen) {
					bodyHeight = $('body').height()
				}
				if (windowBottomScrollPosition > (bodyHeight - 60)) {
					isFixedPosition = false;
					$heroBtn.css('position', 'static')
				} else {
					isFixedPosition = true;
					$heroBtn.css('position', 'fixed')
				}
			})
		}
		
	}
}

/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorAll.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.loan_calculator_all) {

        window.intesa.loan_calculator_all = new Intesa.LoanCalculatorAll();

    }

    return window.intesa.loan_calculator_all;

};